export const COMMENTS_ORDER = {
  AESCENDING: "AESCENDING",
  DESCENDING: "DESCENDING",
};
